/* eslint-disable react-hooks/exhaustive-deps */
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import classnames from 'classnames';
import ModalAsistencias from 'components/AutoMex/ModalAsistencias';
import ModalCoberturas from 'components/AutoMex/ModalCoberturas';
import Breadcrumcomponent from 'components/BreadCrumbMex/BreadCrumb';
import BreadCurmbPasos from 'components/BreadCrumbMex/BreadCrumbTipo2';
import useIsCompraFinalizada from 'components/Crons/useIsCompraFinalizada';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { DropDown } from 'components/InputsMex/inputs';
import Page from 'components/Page';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_8 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import useAlbert from 'hooks/useAlbert';
import useUsuario from 'hooks/useUsuario';
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Row } from 'reactstrap';
import { setBanderaPrimerPago, setParametrosPago } from 'redux/actions/cotizacion.actions';
import { PASOS_BREADCRUMBS, PRODUCTOS } from 'utils/constants';
import { getColorByPlan } from 'utils/funciones';
import Loading from 'wrappers/Loading';
import iconCar from '../../assets/img/mex/auto/icon-planes.png';
import './styles.scss';
import { urlGuardarSeleccionarPlan, urlPlanes, urlRecuperarCotizacionPaginaDos } from './urls';

const SeleccionaPlanPantalla2 = ({ history, params: { idCotizacion }, qParams: { recuperar }, addWarningToast }) => {
  useNavbarContext(PRODUCTOS.APINDIVIDUAL);
  useIsCompraFinalizada({ id: idCotizacion, ramo: PRODUCTOS.AUTO });
  const methods = useForm({ mode: 'onChange' });
  const { handleSubmit, reset } = methods;

  const [loading, setLoading] = useState(true);
  const [datosPlanes, setDatosPlanes] = useState({});
  const { cliCodigoCore } = useUsuario();
  const codProducto = 'AUTO';
  const [clasePlan, setClasePlan] = useState('heigt-coberturas');
  const [datosDeducicbles, setDatosDeducibles] = useState({});
  const [btnActualizarTarifa, setBtnActualizarTarifa] = useState(false);
  const { addAutoEvent, AUTO_EVENTS, AUTO_OPERATIONS } = useAlbert();

  const dispatch = useDispatch();

  const getData = async () => {
    setLoading(true);
    if (recuperar) {
      const DataResumen = {
        ambiente: ambienteAplicacion,
        cotDatos: { ambiente: ambienteAplicacion, cotCodigo: idCotizacion },
      };
      const resResumen = await ApiKeyFetch.instance().post(urlRecuperarCotizacionPaginaDos, DataResumen);

      if (resResumen.transaccion) {
        //Agregar Validacion de poliza finalizada
        if (resResumen?.cotConsulta?.polizaFinalizada) {
          addWarningToast(
            'No se puede modificar esta cotización puesto que ya se ha finalizado el proceso de emisión.'
          );
          history.push('/auto');
        }
        if (resResumen.cotConsulta?.prodDatos) {
          const dataCargar = {
            modeloAuto: resResumen.cotConsulta.carContratante.datosPlan.modeloAuto,
            planes: resResumen.cotConsulta.prodDatos,
          };
          setDatosPlanes(dataCargar);
          //verificar clase
          const result = dataCargar?.planes?.filter((item) => item.id === 'gold');
          if (result.length === 0) {
            setClasePlan('singold');
          }

          //----- Agentes y Brokers deducibles
          if (resResumen?.cotConsulta?.catalogos?.deducibles) {
            const cargaDeducibles = resResumen?.cotConsulta?.catalogos?.deducibles;
            setDatosDeducibles(cargaDeducibles);
            if (
              cargaDeducibles?.defaultDeducibleDM &&
              cargaDeducibles?.defaultDeducibleRT &&
              cargaDeducibles?.defaultSARC &&
              cargaDeducibles?.defaultSAGM
            ) {
              reset({
                deducibleDM: cargaDeducibles?.defaultDeducibleDM?.value,
                deducibleRT: cargaDeducibles?.defaultDeducibleRT?.value,
                sumaAseguradaRC: cargaDeducibles?.defaultSARC?.value,
                sumaAseguradaGM: cargaDeducibles?.defaultSAGM?.value,
              });
            }
          }
          //----- Fin Agentes y Brokers deducibles
        } else {
          await cargarPosiblesPlanes();
        }
      }
    } else if (idCotizacion) {
      await cargarPosiblesPlanes();
    }

    setLoading(false);
  };

  const cargarPosiblesPlanes = async (deduciblesEnviar = null) => {
    const body = {
      ambiente: ambienteAplicacion,
      datosCotizador: {
        prodCodigo: 'AUTO',
        cotPasoCodigo: 'planes',
        id: idCotizacion,
        codigoUsuario: cliCodigoCore || '',
      },
    };
    if (deduciblesEnviar !== null) {
      body.items = deduciblesEnviar;
    }
    const { transaccion, catalogo } = await ApiKeyFetch.instance().post(urlPlanes, body);

    if (transaccion) {
      setDatosPlanes(catalogo);
      // dispatch(setBanderaPrimerPago(catalogo?.banderaPrimerPago || false));
      // --- Verificar si vienen los totales
      const mostrarmensaje = false;

      if (mostrarmensaje && mostrarmensaje === true) {
        addWarningToast('No se ha podido obtener un valor de prima con la información ingresada.', {
          autoDismiss: false,
        });
      }
      const result = catalogo?.planes?.filter((item) => item.id === 'gold');
      if (result.length === 0) {
        setClasePlan('singold');
      }
      // --- Fin Verificar si vienen los totales
      //----- Agentes y Brokers deducibles
      if (catalogo?.deducibles) {
        setDatosDeducibles(catalogo?.deducibles);

        if (
          catalogo?.deducibles?.defaultDeducibleDM &&
          catalogo?.deducibles?.defaultDeducibleRT &&
          catalogo?.deducibles?.defaultSARC &&
          catalogo?.deducibles?.defaultSAGM
        ) {
          reset({
            deducibleDM: catalogo?.deducibles?.defaultDeducibleDM?.value,
            deducibleRT: catalogo?.deducibles?.defaultDeducibleRT?.value,
            sumaAseguradaRC: catalogo?.deducibles?.defaultSARC?.value,
            sumaAseguradaGM: catalogo?.deducibles?.defaultSAGM?.value,
          });
        }
      }
      //----- Fin Agentes y Brokers deducibles
    } else {
      addWarningToast(catalogo?.error);
    }
  };

  useEffect(() => {
    console.log('RENDER');
    obtenerParametros();
    getData();
  }, []);

  const obtenerParametros = () => {
    const DataParametros = {
      datosPago: {
        ambiente: ambienteAplicacion,
        cotPasoCodigo: 'obtenerParametros',
        prodCodigo: PRODUCTOS.AUTO,
        //polCodigo: idPoliza,
        numTarjeta: '4656565',
        idCotizacion: idCotizacion,
      },
    };

    ApiKeyFetch.instance()
      .post(URLS_PHP_8.emision.pago, DataParametros)
      .then((res) => {
        if (res.transaccion) {
          dispatch(setParametrosPago(res.pago));
        }
      });
  };

  const onSubmit = async () => {
    setLoading(true);

    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: 'AUTO',
      pasoCodigo: 'planSelecionado',
      items: {
        cotCodigo: idCotizacion,
        planes: datosPlanes.planes,
      },
    };

    // Agregando evento Albert ----------------------------
    addAutoEvent(AUTO_OPERATIONS.albert_dtc_auto, AUTO_EVENTS.albert_choose_plan);
    // Fin Agregando evento Albert ----------------------------
    const res = await ApiKeyFetch.instance().post(urlGuardarSeleccionarPlan, Data);

    if (res.transaccion) {
      history.replace(`/auto-planes/${res?.id}?recuperar=true`);
      history.push(`/auto-resumen/${res.id}`);
    }
    setLoading(false);
  };

  const onClickAtras = () => {
    history.push(`/auto/${idCotizacion}`);
  };

  const onClickSeleccionar = (plan, producto) => (event) => {
    try {
      mapProductos(producto, plan);
    } catch (error) {}
  };

  const mapProductos = (producto, plan) => {
    const newProductos = producto.planes.map((item) => {
      delete item.seleccionado;
      if (item.id === plan.id) {
        item.seleccionado = true;
      }
      return { ...item };
    });
    datosPlanes.planes = newProductos;
    setDatosPlanes({ ...datosPlanes });
  };

  const onChangeDeducibles = () => {
    setBtnActualizarTarifa(true);
  };
  const onClickActualizarTarifa = async () => {
    const deducibleDMAx = methods.watch('deducibleDM');
    const deducibleRTAx = methods.watch('deducibleRT');
    const sumaAseguradaRCAx = methods.watch('sumaAseguradaRC');
    const sumaAseguradaGMAx = methods.watch('sumaAseguradaGM');
    const dataEnviar = {
      editarTarifa: true,
      deducibleDM: {
        label: deducibleDMAx?.label,
        value: deducibleDMAx,
      },
      deducibleRT: {
        label: deducibleRTAx?.label,
        value: deducibleRTAx,
      },
      sumaAseguradaRC: {
        label: sumaAseguradaRCAx?.label,
        value: sumaAseguradaRCAx,
      },
      sumaAseguradaGM: {
        label: sumaAseguradaGMAx?.label,
        value: sumaAseguradaGMAx,
      },
    };

    setLoading(true);
    await cargarPosiblesPlanes(dataEnviar);
    setBtnActualizarTarifa(false);
    setLoading(false);
  };

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <Breadcrumcomponent {...PASOS_BREADCRUMBS[codProducto].breadCrumb} />
          <BreadCurmbPasos {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasos[2]} />

          <Row className=" mx-1 mx-sm-0">
            <div className="col-3 col-md-2 text-right align-self-center d-none d-sm-block"></div>
            <div
              className="col-9 col-md-10"
              style={{
                color: '#001871',
                fontSize: '30px',
                paddingBottom: '2rem',
                width: '100%',
                lineHeight: '1em',
              }}
            >
              {datosPlanes.modeloAuto ? datosPlanes.modeloAuto : ''}
            </div>
          </Row>

          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row col-lg-12 content-planes-auto">
                {datosPlanes.planes &&
                  datosPlanes.planes.map((plan, index) => (
                    <React.Fragment key={plan.id}>
                      <div
                        className="col-12 col-md-6 col-lg-3 col-xl-3 ap mb-5 mb-xl-0 cpointer"
                        key={index}
                        onClick={onClickSeleccionar(plan, datosPlanes)}
                      >
                        {plan.elmasvendido && plan.elmasvendido === true && (
                          <div className={'pleca-planes'}>¡Te recomendamos este paquete para tu auto!</div>
                        )}
                        <div
                          className={classnames({
                            row: true,
                            'plan-autos': true,
                            selected: plan.seleccionado,
                          })}
                        >
                          <div className="col-12">
                            <div className="row justify-content-center mt-4 mb-5">
                              <div
                                className="text-center "
                                style={{
                                  backgroundColor: getColorByPlan(plan.id),
                                  fontSize: '20px',
                                  paddingBottom: '0.5rem',
                                  width: '90%',
                                }}
                              >
                                <h4 className="font-mex title-plan-auto mt-2">{plan.producto}</h4>
                              </div>

                              <div className="col-12">
                                <div className="div text-center">
                                  {/* <h6 className="font-source-sans-regular text-mex my-3">
                                      Prima neta anual
                                    </h6> */}
                                  <br></br>
                                  <img src={iconCar} className="img-fluid" alt="" style={{ height: '90px' }} />
                                  <h5
                                    className="font-mex text-mex mt-3 mb-1"
                                    style={{
                                      fontSize: '30px',
                                      fontWeight: 'bold',
                                      // height: '80px',
                                    }}
                                  >
                                    ${plan?.totales[0]?.primaTotal + ' ' + plan?.totales[0]?.monedaSimbolo}
                                  </h5>

                                  {plan?.primaTotalDividida && plan?.msjPrimaTotal && (
                                    <div>
                                      <div
                                        style={{
                                          color: '#001871',
                                          fontSize: '21px',
                                          padding: '3px',
                                        }}
                                      >
                                        {'$' + plan.primaTotalDividida + ' ' + plan?.totales[0]?.monedaSimbolo + ' '}
                                        <Button
                                          type="button"
                                          label=""
                                          icon="pi pi-question"
                                          tooltip={plan.msjPrimaTotal}
                                          className="btn-info-label"
                                          tooltipOptions={{ position: 'top' }}
                                          style={{ background: '#001871' }}
                                        />
                                      </div>

                                      {/* <div style={{lineHeight:"14px",color:"#001871", fontSize:"15px"}}>{plan.msjPrimaTotal}</div> */}
                                      <br></br>
                                    </div>
                                  )}

                                  <div className={`mt-3 ${clasePlan}`}>
                                    {plan.coberturas &&
                                      plan.coberturas.map((cob, index) => {
                                        return (
                                          <React.Fragment key={index}>
                                            <div className="tex-coberturas">{cob.nombre}</div>
                                          </React.Fragment>
                                        );
                                      })}
                                  </div>
                                  {plan.codAsistenciasAdicional && (
                                    <ModalAsistencias ocupaciones={plan.codAsistenciasAdicional} />
                                  )}
                                  {plan.codCoberturasAdicional && (
                                    <ModalCoberturas ocupaciones={plan.codCoberturasAdicional} />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row justify-content-center mt-3 margin-btn-elegir">
                          <button
                            className={classnames({
                              'btn-select-plan-ap btn-elegir-plan-auto': true,
                              selected: plan.seleccionado,
                            })}
                            type="button"
                          >
                            Elijo este paquete
                          </button>
                        </div>
                      </div>
                    </React.Fragment>
                  ))}
              </div>

              {/* Personaliza tus coberturas              */}
              <div className=" col-lg-12">
                <div className=" col-lg-12">
                  <h3>Personaliza tus coberturas</h3>
                </div>
                <div className="row my-5">
                  <div className="col-12 col-md-6 col-xl-3">
                    <SimpleContainer
                      label="Deducible (daños materiales)"
                      labelClass="labelDropDownAuto"
                      name="deducibleDM"
                      info={datosDeducicbles?.infoDeducibleDM}
                    >
                      <DropDown
                        rules={{ required: 'Obligatorio' }}
                        name="deducibleDM"
                        includePlaceholder={false}
                        options={datosDeducicbles?.deducibleDM}
                        onChangeFn={onChangeDeducibles}
                      />
                    </SimpleContainer>
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <SimpleContainer
                      label="Deducible (robo total)"
                      labelClass="labelDropDownAuto"
                      name="deducibleRT"
                      info={datosDeducicbles?.infoDeducibleRT}
                    >
                      <DropDown
                        rules={{ required: 'Obligatorio' }}
                        name="deducibleRT"
                        includePlaceholder={false}
                        options={datosDeducicbles?.deducibleRT}
                        onChangeFn={onChangeDeducibles}
                      />
                    </SimpleContainer>
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <SimpleContainer
                      label="Suma Asegurada (Responsabilidad civil)"
                      labelClass="labelDropDownAuto"
                      name="sumaAseguradaRC"
                      info={datosDeducicbles?.infoSumaRC}
                    >
                      <DropDown
                        rules={{ required: 'Obligatorio' }}
                        name="sumaAseguradaRC"
                        includePlaceholder={false}
                        options={datosDeducicbles?.sumaAseguradaRC}
                        onChangeFn={onChangeDeducibles}
                      />
                    </SimpleContainer>
                  </div>
                  <div className="col-12 col-md-6 col-xl-3">
                    <SimpleContainer
                      label="Suma Asegurada (Gastos médicos)"
                      labelClass="labelDropDownAuto"
                      name="sumaAseguradaGM"
                      info={datosDeducicbles?.infoSumaGM}
                    >
                      <DropDown
                        rules={{ required: 'Obligatorio' }}
                        name="sumaAseguradaGM"
                        includePlaceholder={false}
                        options={datosDeducicbles?.sumaAseguradaGM}
                        onChangeFn={onChangeDeducibles}
                      />
                    </SimpleContainer>
                  </div>
                </div>
              </div>
            </form>
          </FormProvider>

          <div className="row justify-content-center my-5">
            <div className="col-4 col-md-3 col-xl-2">
              <button className="btn btn-atras-api" onClick={onClickAtras}>
                Atrás
              </button>
            </div>
            <div className="col-4 col-md-3 col-xl-2">
              <button
                className={btnActualizarTarifa === true ? 'btn btn-calcular-api' : 'btn btn-siguiente-api'}
                onClick={btnActualizarTarifa === true ? onClickActualizarTarifa : onSubmit}
              >
                {btnActualizarTarifa === true ? 'Calcular Valores' : 'Siguiente'}
              </button>
            </div>
          </div>
        </Page>
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(SeleccionaPlanPantalla2);
